import styled from 'styled-components';
import {
  BaseListContainer,
} from '../shared/SharedListStyles';

export const Container = styled(BaseListContainer)`
  width: 100%;
  .collapsible-filter-builder-body {
    z-index: 2;
  }
`;
